import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const CreateSegment = lazy(() => import("../pages/create-segment"));
const SegmentHistory = lazy(() => import("../pages/segment-history"));
const Segmentlisting = lazy(() => import("../pages/segment-listing"));
const SegmentDetails = lazy(() => import("../pages/segment-details"));
const SegmentDashboard = lazy(() => import("../pages/segment-dashboard"));
const RecommendedSegments = lazy(() => import("../pages/recommended-segments"));

export const SegmentRouter = [
  {
    path: "segment",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <SegmentDashboard />
          </Suspense>
        ),
      },
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Segmentlisting />
          </Suspense>
        ),
      },
      {
        path: "all/:type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Segmentlisting />
          </Suspense>
        ),
      },
      {
        path: "recommended",
        element: (
          <Suspense fallback={<Backdrop />}>
            <RecommendedSegments />
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateSegment key={"add"} type="add" />
          </Suspense>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateSegment key={"edit"} type="edit" />
          </Suspense>
        ),
      },
      {
        path: "history",
        element: (
          <Suspense fallback={<Backdrop />}>
            <SegmentHistory />
          </Suspense>
        ),
      },
      {
        path: "details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <SegmentDetails />
          </Suspense>
        ),
      },
    ],
  },
];
